"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withExperimentalExport = void 0;
var _react = _interopRequireDefault(require("react"));
var _ExperimentalInformation = _interopRequireDefault(require("./ExperimentalInformation"));
var _processService = require("../../service/process/processService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var withExperimentalExport = exports.withExperimentalExport = function withExperimentalExport(ExperimentalComponent, componentInfo) {
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return (0, _processService.isDevelopment)() ? /*#__PURE__*/_react["default"].createElement(_ExperimentalInformation["default"], {
      componentInfo: componentInfo
    }, /*#__PURE__*/_react["default"].createElement(ExperimentalComponent, _extends({}, props, {
      ref: ref
    }))) : /*#__PURE__*/_react["default"].createElement(ExperimentalComponent, _extends({}, props, {
      ref: ref
    }));
  });
};